/* eslint-disable
    no-eq-null,
*/
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'
import moment from 'moment'

export default ReportManager

/** @ngInject */
function ReportManager($rootScope, ContractStatus) {
    return {
        allowedReportStatus: [ContractStatus.enService, ContractStatus.enAttenteReleve],
        class: 'read',
        contract: null,
        values: [],
        message: null,
        canEditStatus: {
            isContractDefined: false,
            isNotReportedToday: false,
            isAllowedReportStatus: false,
        },
        updateContract(contract) {
            this.contract = contract
            this.values = contract != null ? contract.lastReadings : undefined
            this.message = null
            const lastReportDate = get(this.contract, 'lastReadings[0].end_date')
            this.canEditStatus = {
                isContractDefined: !isEmpty(contract),
                isNotReportedToday: isEmpty(lastReportDate) || !moment().isSame(moment(lastReportDate), 'day'),
                isAllowedReportStatus: this.allowedReportStatus.indexOf(this.contract.status) > -1,
            }
            return $rootScope.$emit('lastReadings updated')
        },
        canEdit() {
            return this.canEditStatus.isContractDefined && this.canEditStatus.isNotReportedToday && this.canEditStatus.isAllowedReportStatus
        },
        updateClass(newClass) {
            if ((newClass === 'input') && !this.canEdit()) {
                return
            }
            this.class = newClass
        },
        watch(callback) {
            const self = this
            return $rootScope.$on('lastReadings updated', () => callback(self.contract))
        },
    }
}



// WEBPACK FOOTER //
// ./src/models/reports.js